import { ItemReducerV2 } from "@green24/npm-preact-utils/store";
import { applicationActions, configurationActions, locationActions, settingsActions } from "../actions/actions";
import { M_Application } from "../../models/Models_Application";

ItemReducerV2.initialState.fetching = false;

export default {
	application: ItemReducerV2(applicationActions.key,  {
		editOnly: true,
		initialState: {
			...ItemReducerV2.initialState,
			edit: M_Application,
		},
	}),
	configuration: ItemReducerV2(configurationActions.key, {
		editOnly: true,
		initialState: {
			...ItemReducerV2.initialState,
			fetching: true,
		},
	}),
	settings: ItemReducerV2(settingsActions.key),
	location: ItemReducerV2(locationActions.key),
};
